import React, { useEffect, useState } from 'react'
import { useForm, Controller } from "react-hook-form";
import style from './ReactivateAccount.module.css';
import { AppDispatch } from '../../redux/rootReducer';
import { useDispatch } from 'react-redux';
import TinyLoader from '../tiny-loader/TinyLoader';
import { REGEX } from '../../constants/regex';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactivateAccountRequest } from '../../redux/auth/actions/reactivateAccount.action';
import Toast from '../toast/Toast';

const ReactivateAccount = () => {

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const dispatch: AppDispatch = useDispatch();
  const params = useParams();
  const email = params.email;

  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState('error');
  const [toastMessage, setToastMessage] = useState('');

  const navigate = useNavigate();

  const {
    handleSubmit,
    setValue,
    formState: { isValid, errors, isDirty },
    control,
  } = useForm({
    defaultValues: {
      email: ''
    },
    mode: "onChange",
  });

  useEffect(() => {
    if (email) {
      setValue('email', email)
    } else {
      setValue('email', '')
    }
  }, [email])

  const onSuccess = (message: string) => {
    setToastMessage(message);
    setToastType('success');
    setShowToast(true);
    setIsLoading(false);
  }

  const onFailure = (message: string) => {
    setToastMessage(message);
    setToastType('error');
    setShowToast(true);
    setIsLoading(false);
  }

  const onSubmit = async (data: { email: string }) => {
    setIsLoading(true);
    const email = data?.email;
    const encodedEmail = encodeURIComponent(email);
    dispatch(ReactivateAccountRequest(encodedEmail, onSuccess, onFailure));
  };

  useEffect(() => {
    if (showToast) {
      setTimeout(() => {
        setShowToast(false);
      }, 4000);
    }
  }, [showToast])


  return (
    <div className={style.profileContainer}>
      <div className={style.innerContainer}>
        <form onSubmit={handleSubmit(onSubmit)} className={style.formWrapper} noValidate>
          <h2 className={style.authTitle}>Reactivate Account</h2>
          <p className={style.desc}>Your account is currently deactivated. To reactivate it, simply click the 'Reactivate Account' button below.</p>
          <Controller
            name="email"
            control={control}
            rules={{
              required: "Email is required",
              pattern: {
                value: REGEX.EMAIL,
                message: "Please enter a valid email address",
              }
            }}
            render={({ field: { value, onChange } }) => {
              return (<div className={style.fieldWrapper}>
                <label>Email</label>
                <div className={style.passwordWrapper}>
                  <input
                    value={value}
                    type="email"
                    onChange={onChange}
                    id="email"
                    name="email"
                    placeholder="Enter your email address"
                  />
                </div>
                {errors?.email && <p className={style.errorText}>{errors?.email?.message}</p>}
              </div>)
            }}
          />

          <div className={style.buttonContainer}>
            <div className={style.submitWrapper}>
              <button type="submit" disabled={(isValid && !isDirty) || isLoading}>{<span className={isLoading ? style.loader : ''}>{isLoading ? <TinyLoader /> : 'Reactivate Account'}</span>}</button>
            </div>
          </div>

          <div className={style.backSignin}>
            <button onClick={() => navigate('/login')}>Back to Login</button>
          </div>

        </form>
      </div>

      {showToast && <Toast message={toastMessage} type={toastType} />}
    </div>
  )
}

export default ReactivateAccount
